import React from 'react';
import { Box, HintPlacement, InfoOutlineIcon, SimpleHint, Text } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { DEFAULT_DATE_FORMAT } from '@/common/constants';

import { TaxFormHistoryItem } from './TaxForms.types';
interface Props {
  items?: TaxFormHistoryItem[];
}
const TaxFormsMessageQueue: React.FC<Props> = ({ items }) => {
  if (!items || !items.length) {
    return null;
  }

  return (
    <Box
      data-testid="tax-form_message-queue"
      direction="row"
      align="center"
      justify="center"
      margin={{ right: 'spacing24' }}
      pad={{ right: 'psacing12' }}
    >
      <Text
        data-testid="tax-form_message-queue_count"
        size="medium"
        color="success"
        margin={{ right: 'spacing4' }}
        weight={400}
      >
        Mailed ({items.length})
      </Text>
      <Box height="21px">
        <SimpleHint
          width="180px"
          preferAlign={HintPlacement.TOP}
          content={
            <Box align="start" data-testid="tax-form_message-queue_history" direction="column">
              <Text
                data-testid="tax-form_message-queue_history_title"
                size="small"
                weight={700}
                margin={{ bottom: 'spacing4' }}
              >
                Mailing history:
              </Text>
              {items.map((items, index) => (
                <Box key={index} direction="row" align="center">
                  <Text
                    data-testid={`tax-form_message-queue_history_item_${index}`}
                    size="small"
                    weight={500}
                    margin={{ left: 'spacing2' }}
                  >
                    {index + 1}. {dayjs(items.date).format(DEFAULT_DATE_FORMAT)} — {items.status}
                  </Text>
                </Box>
              ))}
            </Box>
          }
        >
          <InfoOutlineIcon size="16px" color="iconSecondary" />
        </SimpleHint>
      </Box>
    </Box>
  );
};

export default TaxFormsMessageQueue;
